import { useCallback } from "react";

import type * as Model from "../type";

export const useSearchModelConverter = () => {
	const onConvertSearchModel = useCallback((): Model.SearchModel => {
		return {
			isAcceptMailMagazineChecked: false,
			isLocalPaymentChecked: false,
		} satisfies Model.SearchModel;
	}, []);

	return {
		onConvertSearchModel,
	};
};
